import { RefObject, useEffect } from 'react';

/**
 * Sets a block's height to the window's height while the window is wider than
 * 768px, and back to auto below that. A table block grows past it to fit its
 * content, so on those it is a minimum.
 * @param blockRef - The block to size
 */
const useFullHeight = (blockRef: RefObject<HTMLElement>) => {
  useEffect(() => {
    const block = blockRef.current;

    if (!block) return;

    const size = () => {
      const { clientWidth, clientHeight } = document.documentElement;

      block.style.height = clientWidth > 768 ? `${clientHeight}px` : 'auto';
    };

    let width = document.documentElement.clientWidth;

    const onResize = () => {
      if (document.documentElement.clientWidth === width) return;

      width = document.documentElement.clientWidth;
      size();
    };

    size();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [blockRef]);
};

export default useFullHeight;
